import React from 'react';

import { BaseIconProps } from '.';

export const InfoOutlined = ({ fill }: BaseIconProps) => (
  <g>
    <g>
      <g>
        <g>
          <g>
            <g>
              <path
                fill={fill}
                d="M539.7,1080C242.2,1080,0.2,838,0.2,540.5S242.2,1,539.7,1h1.3c297.2,0.4,538.6,242.4,538.2,539.5
							C1079.2,838,837.2,1080,539.7,1080z M539.7,72.9c-257.8,0-467.6,209.8-467.6,467.6s209.8,467.6,467.6,467.6
							s467.6-209.8,467.6-467.6c0.1-124.8-48.3-242.1-136.4-330.4S665.6,73.1,540.9,72.9H539.7z"
              />
            </g>
          </g>
        </g>
      </g>
      <g>
        <g>
          <path
            fill={fill}
            d="M539.9,390.5c17.6,0,30.9-4.2,39.8-12.7c8.8-8.4,13.2-20.1,13.2-35.2c0-31.8-17.7-47.7-53-47.7
					c-35.4,0-53.1,15.8-53.1,47.6C486.8,374.5,504.5,390.5,539.9,390.5z M588.4,792.3V434.9H491v357.4H588.4z"
          />
        </g>
      </g>
    </g>
  </g>
);
